"use client";
import type { ReactNode } from "react";
import { Button, type ButtonProps } from "@ecco/ui/button";
import { Flex } from "@ecco/ui/flex";
import { ECCOIcon } from "@ecco/ui/ecco-icon";
import { Skeleton } from "@ecco/ui/skeleton";

interface CTAConfig extends ButtonProps {
    label?: ReactNode;
    href?: string;
}

interface CTABarProps {
    buttons: CTAConfig[];
    isLoading?: boolean;
}

export const CTABar = ({ buttons, isLoading }: CTABarProps) => (
    <Flex wrap="wrap" justifyContent="start" gap={0.2} w={["100%", "auto"]} px={[3, 4, 6]}>
        {isLoading
            ? buttons.map((_, i) => <Skeleton key={i} h={10} w="140px" />)
            : buttons.map(({ label, ...props }, i) => (
                  <Button
                      key={i}
                      rightIcon={<ECCOIcon name="arrow-right" />}
                      variant="standard"
                      textDecoration="none"
                      h={10}
                      w="auto"
                      _hover={{ textDecoration: "none" }}
                      {...props}
                  >
                      <span>{label}</span>
                  </Button>
              ))}
    </Flex>
);
